module.exports = "<div class=\"embed-container\">\n  <iframe *ngIf=\"data.id\" [src]=\"url\" width=\"820\" height=\"460\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n</div>\n<hr/>\n<div style=\"text-align: right\">\n  <!-- <button class=\"btn btn-default\" *ngIf=\"data.userOpened\" (click)=\"onDontShowAgain()\">Disable tutorials</button>   -->\n  <button class=\"btn btn-primary\" (click)=\"onOk()\">Got it!</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/vimeo-modal/vimeo-modal.component.html
// module id = ./src/app/shared/components/vimeo-modal/vimeo-modal.component.html
// module chunks = main